<template>
    <div>
        <div id="prestige_section">
            <div v-if="isShow">
                <div class="prestige-headline">{{profileLbl.top_headline}}</div>
                <div class="prestige-message">{{profileLbl.top_message}}</div>
                <table id="prestige_table">
                    <thead>
                        <tr class="prestige-row">
                            <th class="prestige-head prestige-subject">{{lbl.profile.column_privilege}}</th>
                            <th class="prestige-head prestige-quota">{{lbl.profile.column_quota}}</th>
                            <th class="prestige-head prestige-available">{{lbl.profile.column_left}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="prestige-row"
                            v-for="(privilege, k) in list"
                            :key="k">
                        <td class="prestige-subject">{{privilege.Name}}</td>
                        <td class="prestige-quota">{{privilege.Quota}}</td>
                        <td class="prestige-available">{{privilege.Available >= 0 ? privilege.Available : 0}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="prestige-headline remark">{{profileLbl.bottom_headline}}</div>
            <div class="prestige-message">{{profileLbl.bottom_message}}</div>
        </div>
    </div>
</template>
<script>
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
export default {
    name: 'ProfilePrivilegeList',
    mixins: [AccountMixin],
    props: {
        lbl: Object,
        localeCode: Number,
        privilegeList: Object
    },
    data: function () {
        return {
            isShow: false,
            list: [],
            profileLbl: {}
        }
    },
    watch: {
        privilegeList: function (newList) {
            this.initialList(newList);
        }
    },
    created: function () {
        this.getProfileLbl();
        this.initialList(this.privilegeList);
    },
    methods: {
        initialList: function (newList) {
            for (var privilege of newList.Privileges) {
                if (privilege.Tier != 'AMBASSADOR'
                    && privilege.Group != '7'
                    && privilege.Group != '8'
                    && privilege.Quota > 0) {
                        this.isShow = true;
                        this.list.push(privilege);
                    }
            }
        },
        getProfileLbl: function () {
            this.profileLbl = this.$store.getters.getProfileLblByLocaleCode(this.localeCode);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#prestige_section {
    .prestige-headline {
        margin-bottom: 9px;
        //font
        color: $prestige_font_color;
        font-size: 1.375rem;
        // font-family: $heading;
        // letter-spacing: 0.5px;
        // line-height: 1;

        &.remark {
            margin-bottom: 12px;
        }
    }

    .prestige-message {
        margin-bottom: 9px;
        //font
        color: $prestige_font_color;
        font-size: 0.9rem;
        // font-family: $heading;
        // letter-spacing: 0.5px;
        // line-height: 1;
    }

    #prestige_table {
        width: 100%;
        margin-bottom: 15px;
        background: #ffffff;
        //font
        color: $prestige_font_color;
        font-size: 1.2rem;
        // font-family: $heading;
        word-break: break-word;
        // letter-spacing: 0.5px;
        // line-height: 1;

        .prestige-row {
            border: 1px solid #707070;

            th {
                padding: {
                    top: 7px;
                    bottom: 7px;
                };
            }

            td {
                padding: {
                    top: 10px;
                    bottom: 10px;
                };
                vertical-align: top;
            }

            .prestige-subject {
                padding: {
                    left: 10px;
                    right: 10px;
                };
                // line-height: 0.8;
            }

            .prestige-icon {
                text-align: center;
            }

            %baseQuota {
                font-size: 1.2rem;
                // font-family: $everest_condensed;
                text-align: center;
                // line-height: 0.95;
            }

            .prestige-quota {
                @extend %baseQuota;
                width: 60px;
            }

            .prestige-available {
                @extend %baseQuota;
                width: 75px;
            }

            .prestige-icon {
                width: 30px;
                padding-right: 10px;

                img {
                    width: 17px;
                    height: 17px;
                    border-radius: 17px;
                    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
                }
            }

            .prestige-head {
                font-size: 1.2rem;
                // font-family: $heading;
                font-weight: normal;
            }
        }
    }
}
</style>
